import { UITypes } from 'LibNeo'

export enum BgCreateWarning {
	NONE,
	PURCHASE_NOT_FOUND,
	ORGANIZATION_NOT_FOUND,
	INN_PURCHASE_NOT_FOUND,
	ANY,
	POLICY_ERROR,
	MULTI_POLICY_ERROR,
	GUARANTEE_TYPE_ERROR,
	IKZ_INVALID,
	IKZ_IS_REQUIRED,
	EQUAL_TO_PARTNER_INN,
	EQUAL_TO_PRINCIPAL_INN,
	PURCHNAME_IS_REQUIRED,
	EIS_ERROR,
}

export const BgCreateWarningTranslate = {
	[BgCreateWarning.PURCHASE_NOT_FOUND]: 'Отсутствуют сведения по введённому номеру закупки',
	[BgCreateWarning.ORGANIZATION_NOT_FOUND]: 'Отсутствуют сведения по введённому ИНН',
	[BgCreateWarning.INN_PURCHASE_NOT_FOUND]:
		'Отсутствуют сведения по введённому ИНН и номеру закупки',
	[BgCreateWarning.ANY]: 'Возникли ошибки при создании заявки',
	[BgCreateWarning.POLICY_ERROR]:
		'Не удалось создать заявку. Для данного :purchasetype уже зарегистрирована заявка.',
	[BgCreateWarning.MULTI_POLICY_ERROR]:
		'Не удалось создать заявки. Для :count :purchasetype уже зарегистрирована заявка.',
	[BgCreateWarning.GUARANTEE_TYPE_ERROR]: `Закупка не соответствует требованиям!
	На данный момент сервис работает в ограниченном режиме. Мы принимаем заявки только по 44-ФЗ и 223-ФЗ.`,
	[BgCreateWarning.IKZ_INVALID]: `Применительно только при запросе создания заявки.`,
	[BgCreateWarning.EQUAL_TO_PRINCIPAL_INN]: 'Заявитель не может выступать в роли бенефициара',
	[BgCreateWarning.PURCHNAME_IS_REQUIRED]:
		'Банк не выпускает гарантии по закупкам в которых не указан "Объект закупки"',
	[BgCreateWarning.IKZ_IS_REQUIRED]: 'Банк не выпускает гарантии по закупкам без ИКЗ',
	[BgCreateWarning.EIS_ERROR]: 'Не удалось получить сведения о закупке. Повторите попытку позже.',
}

export const BgWarningDescription = {
	[BgCreateWarning.PURCHASE_NOT_FOUND]: {
		title: 'Нет сведений',
		description:
			'Мы не нашли сведений по указанному номеру закупки и не можем создать заявку на выпуск банковской гарантии',
	},
	[BgCreateWarning.ORGANIZATION_NOT_FOUND]: {
		title: 'Нет сведений',
		description:
			'Мы не нашли сведений по указанному ИНН и не можем создать заявку на выпуск банковской гарантии',
	},
	[BgCreateWarning.INN_PURCHASE_NOT_FOUND]: {
		title: 'Нет сведений',
		description:
			'Мы не нашли сведений по указанным ИНН и номеру закупки и не можем создать заявку на выпуск банковской гарантии',
	},
	[BgCreateWarning.ANY]: {
		title: 'Внимание!',
		description: 'Возникли ошибки при создании заявки',
	},
	[BgCreateWarning.POLICY_ERROR]: {
		title: 'Внимание!',
		description:
			'Не удалось создать заявку. Для данного :purchasetype уже зарегистрирована заявка.',
	},
	[BgCreateWarning.MULTI_POLICY_ERROR]: {
		title: 'Внимание!',
		description: 'Не удалось создать заявки. Для :count :purchasetype уже зарегистрирована заявка.',
	},
	[BgCreateWarning.IKZ_INVALID]: {
		title: 'Внимание!',
		description:
			`Ваш запрос не может быть обработан по причине указания в закупке` +
			` некорректного идентификационного кода закупки`,
	},
	[BgCreateWarning.EQUAL_TO_PARTNER_INN]: {
		description:
			'Заявка не может быть создана согласно п. 4.7.3 и п. 4.9.4' +
			' Приложения к Договору «Услуги и Продукты ПАО Сбербанк»',
		actionLinkTitle: 'Подробнее',
		href: 'https://partners.dasreda.ru/knowledge/conditions/partners-project',
	},
}

export class BgWarning<T extends Record<string, string> = Record<string, string>> {
	public type: BgCreateWarning = BgCreateWarning.NONE
	public payload?: T[]

	public constructor(type?: BgCreateWarning, payload?: T[]) {
		if (type) this.type = type
		if (payload) this.payload = payload
	}
}

export const getPrincipalStatus = (agreementStatus: boolean, warning: BgWarning) => {
	if (
		warning.type === BgCreateWarning.ORGANIZATION_NOT_FOUND ||
		warning.type === BgCreateWarning.INN_PURCHASE_NOT_FOUND
	)
		return {
			type: UITypes.DANGER,
			icon: 'alert-circle',
			tooltip: 'Отсутствуют сведения по данному клиенту',
		}
	if (agreementStatus)
		return {
			type: UITypes.PRIMARY,
			icon: 'checkmark-circle-2',
			tooltip: 'Согласие на обработку персональных данных уже получено',
		}
	return {
		type: UITypes.WARNING,
		icon: 'alert-triangle',
		tooltip: 'Данный клиент ещё не передавал согласие на обработку персональных данных',
	}
}
